import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Note: React.StrictMode is intentionally NOT used here.
// react-leaflet v4 throws "Map container is already initialized" on
// StrictMode's deliberate double-mount in dev. Production behaviour is
// unaffected (StrictMode is dev-only).
root.render(<App />);
